import { useEffect } from "react"
import { useState } from "react"
import { Grid, List, ListItem, ListItemText, TextField, Tooltip, Typography, makeStyles } from "@material-ui/core";
import SkeletonLoader from "../../atoms/loader/SkeletonLoader";

const useStyles = makeStyles((theme) => ({
    listContainer: {
        marginTop: 8,
        height: '68vh',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
            width: '0.3em',
            height: '0.3em',
        },
        '&::-webkit-scrollbar-track': {
            boxShadow: 'inset 0 0 6px rgba(0,0,0,0.4)',
            webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.4)',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
            borderRadius: '5px',
        },
        transition: 'height 0.5s ease',
    },
    listItemRoot: {
        paddingTop: 5,
        paddingBottom: 5
    },
    listItemTextRoot: {
        marginTop: 0,
        marginBottom: 0,
        "& .MuiListItemText-secondary": {
            fontSize: "0.75rem",
        },
    }
}));


export const UtilityFunctionList = ({ utilityFunctions, selectedUtilityFunction, isFetching, setSelectedUtilityFunction }) => {
    const classes = useStyles();
    const [filteredUtilityFunctions, setFilteredUtilityFunctions] = useState(utilityFunctions);
    useEffect(() => {
        setFilteredUtilityFunctions(utilityFunctions);
    }, [utilityFunctions]);

    const onSearch = (event) => {
        const keyword = event.target.value.toLowerCase();
        if (!keyword.trim()) {
            setFilteredUtilityFunctions(utilityFunctions);
            return;
        }

        const filtered = utilityFunctions.filter((item) =>
            item.name?.toLowerCase().includes(keyword) ||
            item.body?.toLowerCase().includes(keyword)
        );
        setFilteredUtilityFunctions(filtered);
    };

    const onChangeUtilityFunction = (data) => {
        setSelectedUtilityFunction(data);
    }

    return (
        <>
            <Grid item>
                <TextField
                    name="search"
                    autoFocus
                    fullWidth
                    type={"text"}
                    label={"Search"}
                    placeholder={"Search utility function"}
                    variant="outlined"
                    size={"small"}
                    onChange={onSearch}
                    data-ui-tour-id='search-utility-function'
                />
            </Grid>
            <Grid item className={classes.listContainer}>
                {isFetching &&
                    <SkeletonLoader
                        type="list"
                        listItems={10}
                    />
                }
                {!isFetching &&
                    <List id="utilityFunctions_list" data-ui-tour-id='utility-functions-list'>
                        {filteredUtilityFunctions.length === 0 &&
                            <Grid item xs>
                                <Typography fontFamily="Arial" style={{ float: 'left', marginLeft: 10 }}>
                                    No utility functions
                                </Typography>
                            </Grid>
                        }
                        {filteredUtilityFunctions.length > 0 && filteredUtilityFunctions.map((item, index) => (
                            <Tooltip title={item.name} key={item._id}>
                                <ListItem
                                    button
                                    onClick={() => onChangeUtilityFunction(item)}
                                    selected={item._id == selectedUtilityFunction?._id}
                                    className={classes.listItemRoot}
                                >
                                    <ListItemText
                                        classes={{ root: classes.listItemTextRoot }}
                                        primary={<Typography noWrap style={{ width: '100%' }}>
                                            {item.name}
                                        </Typography>}
                                        secondary={
                                            item.parameters && item.parameters.length > 0
                                                ? item.parameters.map((p) => p.name).join(", ")
                                                : "No parameters"
                                        }
                                    />
                                </ListItem>
                            </Tooltip>
                        ))}
                    </List>
                }
            </Grid>
        </>
    )
}